// eventBus.js
export const eventBus = new EventTarget()